import { Divider as MuiDivider, styled } from '@material-ui/core'
import { compose, display, sizing, spacing } from '@material-ui/system'

const Divider = styled(MuiDivider)(compose(display, sizing, spacing))

export default Divider
